module.exports = __webpack_public_path__ + "static/media/view6.0f26979e.jpg";